import Layout from "../include/layout";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { checkAuthenticate } from "../app/providers/authSlice";
import ClassesService from "../classe/ClassesService";
import $ from "jquery";
import TypesinscriptionsService from "../typesinscriptions/TypesinscriptionsService";
import Filarial from "../include/filarial";
import Joi from "joi-browser";
import Programmesevaluations from "./ProgrammesevaluationsService";
import ProgrammesevaluationsService from "./ProgrammesevaluationsService";
import MatieresService from "../matieres/MatieresService";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import TypesevaluationsService from "../typesevaluations/TypesevaluationsService";
import { Dropdown } from "primereact/dropdown";

export default function ProgrammesevaluationsCreate() {
  const token = useSelector((state) => state.auth.token);
  const activeLink = "PROGRAMMES EVALUATIONS";
  const [errors, setErrors] = useState({});

  //Elément du formulaire d'ajout de grille tarifaire
  const [classesoptions, setClassesoptions] = useState([]);
  const [matieres, setMatieres] = useState([]);
  const [selectedOptionMatiere, setSelectedOptionMatiere] = useState(null);
  const [matiereId, setMatiereId] = useState("");
  const [typesevaluations, setTypesevaluations] = useState([]);
  const [selectedOptionTypeevaluation, setSelectedOptionTypeevaluation] = useState(null);
  const [classeoptionId, setClasseoptionId] = useState("");
  const [selectedOptionClasseoption, setSelectedOptionClasseoption] = useState(null);
  const [typeevaluationId, setTypeevaluationId] = useState("");
  const [dateDebutProgrammeEvaluation, setDateDebutProgrammeEvaluation] =useState("");
  const [dateFinProgrammeEvaluation, setDateFinProgrammeEvaluation] =useState("");
  const [descriptionProgrammeEvaluation, setDescriptionProgrammeEvaluation] =useState("");

  const [selectedOptionCivilite, setSelectedOptionCivilite] = useState(null);

  const navigate = useNavigate();

  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);

  const [validationError, setValidationError] = useState({});


  //get liste matieres
  const fetchMatieres = async () => {
    await MatieresService.index(token)
      .then((response) => {
        setMatieres(response.data.data.matieres);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const datamatieres = matieres.map((item) => ({
    value: item.id,
    label: item.libelleMatiere,
  }));

  //get liste classeoption
  const fetchClassesoptions = async () => {
    await ClassesoptionsService.index(token)
      .then((response) => {
        setClassesoptions(response.data.data.classesoptions);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const dataclassesoptions = classesoptions.map((item) => ({
    value: item.id,
    label: item.libelleClasseOption,
  }));

  //get liste type evaluation
  const fetchTypesevaluations = async () => {
    await TypesevaluationsService.index(token)
      .then((response) => {
        setTypesevaluations(response.data.data.typesevaluations);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const datatypesevaluations = typesevaluations.map((item) => ({
    value: item.id,
    label: item.libelleTypeEvaluation,
  }));

  const handleSubmitData = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append(
      "dateDebutProgrammeEvaluation",
      dateDebutProgrammeEvaluation
    );
    formData.append("dateFinProgrammeEvaluation", dateFinProgrammeEvaluation);
    formData.append("matiereId", selectedOptionMatiere);
    formData.append("classeoptionId", selectedOptionClasseoption);
    formData.append("typeevaluationId", selectedOptionTypeevaluation);
    formData.append(
      "descriptionProgrammeEvaluation",
      descriptionProgrammeEvaluation
    );

    /* for (var pair of formData.entries()) {
          console.log(pair[0]+ ', ' + pair[1]); 
      }*/

    try {
      const response = await ProgrammesevaluationsService.store(
        formData,
        token
      );

      if (response.data.status === 200) {
        //redirection sur index
        navigate(myroutes.programmesevaluations_index);
        Swal.fire({
          icon: "success",
          text: response.data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response.data.message,
          showConfirmButton: true,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: error.message,
      });
    }
  };

  useEffect(() => {
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }

    fetchClassesoptions();
    fetchTypesevaluations();
    fetchMatieres();
  }, [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />

        <div className="row mb-4 mt-3">
          {/* Bootstrap Validation */}
          <div className="col-md">
            <div className="card shadow-lg">
              <h5 className="card-header fw-bold">
                Programmer une nouvelle évaluation{" "}
                <hr/>

              </h5>
              <div className="card-body">
              <Row>
                  {Object.keys(validationError).length > 0 && (
                    <div className="row">
                      <div className="col-12">
                        <div className="alert alert-danger">
                          <ul className="mb-0">{<li>{validationError}</li>}</ul>
                        </div>
                      </div>
                    </div>
                  )}
                </Row>
                <Form
                  className="needs-validation"
                  noValidate
                  onSubmit={handleSubmitData}
                >
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Form.Label
                        className="form-label fw-bold"
                        htmlFor="selectedOptionClasseoption"
                      >
                        Classe option <i className="text-danger">*</i>
                      </Form.Label>
                      <Dropdown
                        required
                        value={selectedOptionClasseoption}
                        onChange={(e) => setSelectedOptionClasseoption(e.value)}
                        options={dataclassesoptions}
                        optionLabel="label"
                        placeholder=" Sélectionner une classe"
                        filter
                        className="w-full md:w-25rem my-custom-class"
                        style={{ width: "100%", height: "40px" }}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <Form.Label
                        className="form-label fw-bold"
                        htmlFor="selectedOptionMatiere"
                      >
                        Matiere <i className="text-danger">*</i>
                      </Form.Label>
                      <Dropdown
                      required
                        value={selectedOptionMatiere}
                        onChange={(e) => setSelectedOptionMatiere(e.value)}
                        options={datamatieres}
                        optionLabel="label"
                        placeholder=" Sélectionner une matiere "
                        filter
                        className="w-full md:w-25rem my-custom-class"
                        style={{ width: "100%", height: "40px" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-email">La date ne doit pas être inférieur à la date d'aujourd'hui</Tooltip>}
                        >
                        <div>
                            <Form.Label
                            className="form-label fw-bold"
                            htmlFor="bs-validation-dateDebutProgrammeEvaluation"
                            >
                            Définir une date de début
                            </Form.Label>
                            <Form.Control
                            required
                            className="form-control"
                            id="dateDebutProgrammeEvaluation"
                            value={dateDebutProgrammeEvaluation}
                            type="date"
                            placeholder=""
                            name="dateDebutProgrammeEvaluation"
                            onChange={(e) =>
                                setDateDebutProgrammeEvaluation(e.target.value)
                            }
                            />
                        </div>
                        </OverlayTrigger>

                    </div>
                    <div className="col-md-6 mb-3">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-email">La date ne doit pas être inférieur à la date d'aujourd'hui</Tooltip>}
                        >
                            <div>
                      <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-dateFinProgrammeEvaluation"
                      >
                        Définir une date de fin
                      </Form.Label>
                      <Form.Control
                      required
                        className="form-control"
                        id="dateFinProgrammeEvaluation"
                        value={dateFinProgrammeEvaluation}
                        type="date"
                        placeholder=""
                        name="dateFinProgrammeEvaluation"
                        onChange={(e) =>
                          setDateFinProgrammeEvaluation(e.target.value)
                        }
                      />
                    </div>
                    </OverlayTrigger>
                    </div>
                  </div>
                  <div className="col-md-12 mb-3">
                                <Form.Label
                                  className="form-label fw-bold"
                                  htmlFor="typeevaluationId"
                                >
                                  Type de l'évaluation <i className="text-danger">*</i>
                                </Form.Label>
                                <Dropdown
                      required
                        value={selectedOptionTypeevaluation}
                        onChange={(e) => setSelectedOptionTypeevaluation(e.value)}
                        options={datatypesevaluations}
                        optionLabel="label"
                        placeholder=" Sélectionner un type  "
                        filter
                        className="w-full md:w-25rem my-custom-class"
                        style={{ width: "100%", height: "40px" }}
                      />
                              </div>
                  <div className=" mb-3">
                    <Form.Label
                      className="form-label fw-bold"
                      htmlFor="descriptionProgrammeEvaluation"
                    >
                      Description <i className="text-danger"></i>
                    </Form.Label>
                    <textarea
                      className="form-control"
                      id="descriptionProgrammeEvaluation"
                      onChange={(e) =>
                        setDescriptionProgrammeEvaluation(e.target.value)
                      }
                      name="descriptionProgrammeEvaluation"
                      rows="3"
                    ></textarea>
                  </div>
                  <div className="row pt-2">
                    <div className="col-12">
                      <button type="submit" className="btn btn-primary">
                        Enregistrer
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          {/* /Bootstrap Validation */}
        </div>
      </div>
    </Layout>
  );
}
